angular.module('mercury.modules.cashup.edit')
.config(["$stateProvider", function($stateProvider) {
  $stateProvider.state('Cashups.Edit', {
    url: '/edit/:reconId',
    templateUrl: 'modules/cashup/edit/edit.tpl.html',
    controller: 'CashupEditCtrl',
    resolve: {
      editable: function() {
        return true;
      }
    }
  });

  $stateProvider.state('Cashups.View', {
    url: '/view/:reconId',
    templateUrl: 'modules/cashup/edit/edit.tpl.html',
    controller: 'CashupEditCtrl',
    resolve: {
      editable: function() {
        return false;
      }
    }
  });
}]);
